import i18n from "../translation/i18n";

export const canAccessReporting = (user) => {
  if (!user) return false;

  const roleName = String(
    user.role || user.role_name || user.account_role || user.user_role || ""
  ).toLowerCase();

  const deniedRoleNames = ["gärtner", "gaertner", "gardener"];
  if (deniedRoleNames.includes(roleName)) return false;

  // Current platform fallback: account_type 2 corresponds to the restricted basic/gardener role.
  if (Number(user.account_type) === 2) return false;

  return true;
};

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  if (!Array.isArray(user?.permissions)) return true;
  const permissions = user.permissions;
  return permissions.includes(permission);
};

export const getPersonaHomePath = (user) => {
  const persona = String(user?.persona || "").toLowerCase();
  switch (persona) {
    case "tree_inspector":
      return "/trees";
    case "irrigation_team":
      return "/tasks";
    case "city_tree_manager":
      return "/dashboard";
    case "research_partner":
      return "/data-science";
    case "treesense_support":
      return "/sensors";
    default:
      return "/dashboard";
  }
};

export const formatPersonaLabel = (persona) => {
  const normalized = String(persona || "").toLowerCase();
  if (!normalized) return "-";

  const translated = i18n.t(`persona_labels.${normalized}`);
  return translated && translated !== `persona_labels.${normalized}` ? translated : "-";
};

export const formatRoleLabel = (role) => {
  const normalized = String(role || "").toLowerCase();
  if (!normalized) return "-";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};
